import {
  GET_GENERAL,
  GET_GENERAL_FAIL,
  GET_GENERAL_SUCCESS,
  GET_GENERAL_SETTING,
  GET_GENERAL_SETTING_FAIL,
  GET_GENERAL_SETTING_SUCCESS,
  UPDATE_GENERAL_SETTING,
  UPDATE_GENERAL_SETTING_FAIL,
  UPDATE_GENERAL_SETTING_SUCCESS,
  RESET_GENERAL_STATE,
  GET_STATE,
  GET_STATE_FAIL,
  GET_STATE_SUCCESS,
  GET_STATE_2,
  GET_STATE_2_FAIL,
  GET_STATE_2_SUCCESS,
  GET_GENERAL_USE,
  GET_GENERAL_USE_FAIL,
  GET_GENERAL_USE_SUCCESS,
  //payment method
  GET_PAYMENT_METHOD,
  GET_PAYMENT_METHOD_FAIL,
  GET_PAYMENT_METHOD_SUCCESS,
  //list 
  GET_PAYMENT_METHOD_LIST,
  GET_PAYMENT_METHOD_LIST_FAIL,
  GET_PAYMENT_METHOD_LIST_SUCCESS,
  //add
  ADD_NEW_PAYMENT_METHOD,
  ADD_PAYMENT_METHOD_SUCCESS,
  ADD_PAYMENT_METHOD_FAIL,
  EDIT_PAYMENT_METHOD,
  EDIT_PAYMENT_METHOD_SUCCESS,
  EDIT_PAYMENT_METHOD_FAIL,
  DELETE_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD_SUCCESS,
  DELETE_PAYMENT_METHOD_FAIL,
  //payment configuration
  GET_PAYMENT_CONFIGURATION_DETAILS,
  GET_PAYMENT_CONFIGURATION_DETAILS_FAIL,
  GET_PAYMENT_CONFIGURATION_DETAILS_SUCCESS,
  ADD_NEW_PAYMENT_CONFIGURATION,
  ADD_PAYMENT_CONFIGURATION_SUCCESS,
  ADD_PAYMENT_CONFIGURATION_FAIL,
  EDIT_PAYMENT_CONFIGURATION,
  EDIT_PAYMENT_CONFIGURATION_SUCCESS,
  EDIT_PAYMENT_CONFIGURATION_FAIL,
  DELETE_PAYMENT_CONFIGURATION,
  DELETE_PAYMENT_CONFIGURATION_SUCCESS,
  DELETE_PAYMENT_CONFIGURATION_FAIL,
  //payment type dp
  GET_PAYMENT_LIST,
  GET_PAYMENT_LIST_FAIL,
  GET_PAYMENT_LIST_SUCCESS,
  //list 
  GET_PAYMENT_GATEWAY,
  GET_PAYMENT_GATEWAY_FAIL,
  GET_PAYMENT_GATEWAY_SUCCESS,
  //paayment type dp 
  GET_PAYMENT_TYPE_DROPDOWN,
  GET_PAYMENT_TYPE_DROPDOWN_FAIL,
  GET_PAYMENT_TYPE_DROPDOWN_SUCCESS,

} from "./actionTypes";

export const getGeneral = () => ({
  type: GET_GENERAL,
});

export const getGeneralSuccess = general => ({
  type: GET_GENERAL_SUCCESS,
  payload: general,
});

export const getGeneralFail = error => ({
  type: GET_GENERAL_FAIL,
  payload: error,
});

//state
export const getState = ({ id }) => ({
  type: GET_STATE,
  payload: { id },
});

export const getStateSuccess = general => ({
  type: GET_STATE_SUCCESS,
  payload: general,
});

export const getStateFail = error => ({
  type: GET_STATE_FAIL,
  payload: error,
});

//state
export const getState2 = ({ id }) => ({
  type: GET_STATE_2,
  payload: { id },
});

export const getState2Success = general => ({
  type: GET_STATE_2_SUCCESS,
  payload: general,
});

export const getState2Fail = error => ({
  type: GET_STATE_2_FAIL,
  payload: error,
});


//get general setting
export const getGeneralSetting = () => ({
  type: GET_GENERAL_SETTING,
});

export const getGeneralSettingSuccess = general => ({
  type: GET_GENERAL_SETTING_SUCCESS,
  payload: general,
});

export const getGeneralSettingFail = error => ({
  type: GET_GENERAL_SETTING_FAIL,
  payload: error,
});

//update general setting
export const updateGeneralSetting = ({ setting }) => ({
  type: UPDATE_GENERAL_SETTING,
  payload: setting,
});

export const updateGeneralSettingSuccess = general => ({
  type: UPDATE_GENERAL_SETTING_SUCCESS,
  payload: general,
});

export const updateGeneralSettingFail = error => ({
  type: UPDATE_GENERAL_SETTING_FAIL,
  payload: error,
});
//general
export const getGeneralUse = () => ({
  type: GET_GENERAL_USE,
});

export const getGeneralUseSuccess = general => ({
  type: GET_GENERAL_USE_SUCCESS,
  payload: general,
});

export const getGeneralUseFail = error => ({
  type: GET_GENERAL_USE_FAIL,
  payload: error,
});

//payment 
export const getPaymentMethod = ({ length, sort, page, name }) => ({
  type: GET_PAYMENT_METHOD,
  payload: { length, sort, page, name },
});

export const getPaymentMethodSuccess = paymentMethod => ({
  type: GET_PAYMENT_METHOD_SUCCESS,
  payload: paymentMethod,
});

export const getPaymentMethodFail = error => ({
  type: GET_PAYMENT_METHOD_FAIL,
  payload: error,
});

//list payment
export const getPaymentMethodListing = ({ length, sort, page }) => ({
  type: GET_PAYMENT_METHOD_LIST,
  payload: { length, sort, page },
});

export const getPaymentMethodListingSuccess = paymentMethod => ({
  type: GET_PAYMENT_METHOD_LIST_SUCCESS,
  payload: paymentMethod,
});

export const getPaymentMethodListingFail = error => ({
  type: GET_PAYMENT_METHOD_LIST_FAIL,
  payload: error,
});

//add 
export const addNewPaymentMethod = paymentMethod => ({
  type: ADD_NEW_PAYMENT_METHOD,
  payload: paymentMethod,
});

export const addPaymentMethodSuccess = paymentMethod => ({
  type: ADD_PAYMENT_METHOD_SUCCESS,
  payload: paymentMethod,
});

export const addPaymentMethodFail = error => ({
  type: ADD_PAYMENT_METHOD_FAIL,
  payload: error,
});

//edit 
export const editPaymentMethod = ({paymentMethod,id })=> ({
  type: EDIT_PAYMENT_METHOD,
  payload: {paymentMethod, id},
});

export const editPaymentMethodSuccess = paymentMethod => ({
  type: EDIT_PAYMENT_METHOD_SUCCESS,
  payload: paymentMethod,
});

export const editPaymentMethodFail = error => ({
  type: EDIT_PAYMENT_METHOD_FAIL,
  payload: error,
});

//delete 
export const deletePaymentMethod = ({paymentMethod,id })=> ({
  type: DELETE_PAYMENT_METHOD,
  payload: {paymentMethod, id},
});

export const deletePaymentMethodSuccess = paymentMethod => ({
  type:  DELETE_PAYMENT_METHOD_SUCCESS,
  payload: paymentMethod,
});

export const deletePaymentMethodFail = error => ({
  type:  DELETE_PAYMENT_METHOD_FAIL,
  payload: error,
});

//details - configure
export const getPaymentConfigurationDetails = ({ id }) => ({
  type: GET_PAYMENT_CONFIGURATION_DETAILS,
  payload: { id },
});

export const getPaymentConfigurationDetailsSuccess = paymentMethod => ({
  type: GET_PAYMENT_CONFIGURATION_DETAILS_SUCCESS,
  payload: paymentMethod,
});

export const getPaymentConfigurationDetailsFail = error => ({
  type: GET_PAYMENT_CONFIGURATION_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewPaymentConfiguration = paymentConfiguration => ({
  type: ADD_NEW_PAYMENT_CONFIGURATION,
  payload: paymentConfiguration,
});

export const addPaymentConfigurationSuccess = paymentConfiguration => ({
  type: ADD_PAYMENT_CONFIGURATION_SUCCESS,
  payload: paymentConfiguration,
});

export const addPaymentConfigurationFail = error => ({
  type: ADD_PAYMENT_CONFIGURATION_FAIL,
  payload: error,
});


//edit 
export const editPaymentConfiguration = ({paymentConfiguration,id })=> ({
  type: EDIT_PAYMENT_CONFIGURATION,
  payload: {paymentConfiguration, id},
});

export const editPaymentConfigurationSuccess = paymentConfiguration => ({
  type: EDIT_PAYMENT_CONFIGURATION_SUCCESS,
  payload: paymentConfiguration,
});

export const editPaymentConfigurationFail = error => ({
  type: EDIT_PAYMENT_CONFIGURATION_FAIL,
  payload: error,
});

//delete 
export const deletePaymentConfiguration = ({id })=> ({
  type: DELETE_PAYMENT_CONFIGURATION,
  payload: { id},
});

export const deletePaymentConfigurationSuccess = paymentConfiguration => ({
  type:  DELETE_PAYMENT_CONFIGURATION_SUCCESS,
  payload: paymentConfiguration,
});

export const deletePaymentConfigurationFail = error => ({
  type:  DELETE_PAYMENT_CONFIGURATION_FAIL,
  payload: error,
});

//payment list
export const getPaymentList = paymentMethod => ({
  type: GET_PAYMENT_LIST,
  payload: paymentMethod,
});

export const getPaymentListSuccess = paymentMethod => ({
  type: GET_PAYMENT_LIST_SUCCESS,
  payload: paymentMethod,
});

export const getPaymentListFail = error => ({
  type: GET_PAYMENT_LIST_FAIL,
  payload: error,
});

//gateway payment
export const getPaymentGateway = () => ({
  type: GET_PAYMENT_GATEWAY,
  payload: {},
});

export const getPaymentGatewaySuccess = paymentMethod => ({
  type: GET_PAYMENT_GATEWAY_SUCCESS,
  payload: paymentMethod,
});

export const getPaymentGatewayFail = error => ({
  type: GET_PAYMENT_GATEWAY_FAIL,
  payload: error,
});

//type payment
export const getPaymentTypeDropdown = () => ({
  type: GET_PAYMENT_TYPE_DROPDOWN,
  payload: {},
});

export const getPaymentTypeDropdownSuccess = paymentMethod => ({
  type: GET_PAYMENT_TYPE_DROPDOWN_SUCCESS,
  payload: paymentMethod,
});

export const getPaymentTypeDropdownFail = error => ({
  type: GET_PAYMENT_TYPE_DROPDOWN_FAIL,
  payload: error,
});

//reset
export const resetGeneralState = () => {
  return {
    type: RESET_GENERAL_STATE,
  }
}

